import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { withRouter } from '../withRouter';
import QRCode from 'qrcode.react';
import "animate.css";
import styles from "components/Room/PlayerList.module.scss";
import { FaCopy, FaTv, } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { getBaseUrl } from "helpers/url";
import { leaveRoom } from "actions/room";

import { CONNECT_ENABLED } from "constants/FeatureFlags";
import { pickImage } from "helpers/webpSupport";
import LogoPng from "images/logo-high-res.png"
import LogoWebp from "images/logo-high-res.webp"
import whosInUnderlinePng from "images/rokuHeros/whos-in-underline.png";
import whosInUnderlineWebp from "images/rokuHeros/whos-in-underline.webp";
import cloudLeftPng from "images/clouds/clouds-qr-screen-left.png";
import cloudLeftWebp from "images/clouds/clouds-qr-screen-left.webp";
import cloudRightPng from "images/clouds/clouds-qr-screen-right.png";
import cloudRightWebp from "images/clouds/clouds-qr-screen-right.webp";
import Player from './Player';
import ConnectInfoModal from './ConnectInfoModal';

const Logo = pickImage(LogoWebp, LogoPng);
const whosInUnderline = pickImage(whosInUnderlineWebp, whosInUnderlinePng);
const cloudLeft = pickImage(cloudLeftWebp, cloudLeftPng);
const cloudRight = pickImage(cloudRightWebp, cloudRightPng);


class PlayerList extends Component {
    static displayName = PlayerList.name;

    constructor(props) {
        super(props);

        this.state = {
            collapse: true,
            notifications: [],
            copiedLink: false,
            copiedMirror: false,
            animateIn: false,
            confirmingClose: false,
            slotMap: {},
            leavingPlayers: {},
            showConnectInfo: false,
        };

        this.notificationId = 0;
        this.unBindPlayerJoined = null;
        this.unBindPlayerLeft = null;
        this.unBindAnimatePotato = null;
    }

    componentWillUnmount() {
        if (this.unBindPlayerJoined) this.unBindPlayerJoined();
        if (this.unBindPlayerLeft) this.unBindPlayerLeft();
        if (this.unBindAnimatePotato) this.unBindAnimatePotato();
        clearInterval(this.locationCheckInterval);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.room.roomOpen && !prevProps.room.roomOpen)) {
            this.setState({ animateIn: true, slotMap: {}, confirmingClose: false });
            setTimeout(() => this.setState({ animateIn: false }), 700);
            if (this.props.room.isHost) {
                //this.setPlayerListeners();
                this.startLocationChecks();
                this.bindNotificationListeners();
            }
        }

        if (this.props.room.roomOpen == false && prevProps.room.roomOpen == true) {
            this.setState({ notifications: [], slotMap: {}, confirmingClose: false, leavingPlayers: {} });
        }

        // Sync slotMap when players change
        if (this.props.room.players !== prevProps.room.players) {
            this.updateSlotMap();
        }
    }

    updateSlotMap() {
        const maxPlayers = 8;
        const players = this.props.room.players || [];
        const prevPlayers = this.prevPlayers || [];
        const slotMap = { ...this.state.slotMap };
        const leavingPlayers = { ...this.state.leavingPlayers };
        let changed = false;

        // IDs currently in a leaving animation
        const leavingIds = new Set(Object.keys(leavingPlayers));

        for (const player of players) {
            // Player returned — cancel leaving animation
            if (player.id in leavingPlayers) {
                delete leavingPlayers[player.id];
                leavingIds.delete(player.id);
                changed = true;
            }
            if (!(player.id in slotMap)) {
                for (let i = 0; i < maxPlayers; i++) {
                    if (!Object.values(slotMap).includes(i)) {
                        slotMap[player.id] = i;
                        changed = true;
                        break;
                    }
                }
                // All slots occupied — steal one from a leaving player
                if (!(player.id in slotMap) && leavingIds.size > 0) {
                    const stealId = leavingIds.values().next().value;
                    slotMap[player.id] = slotMap[stealId];
                    delete slotMap[stealId];
                    delete leavingPlayers[stealId];
                    leavingIds.delete(stealId);
                    changed = true;
                }
            }
        }

        const currentIds = new Set(players.map(p => p.id));
        for (const id of Object.keys(slotMap)) {
            if (!currentIds.has(id) && !(id in leavingPlayers)) {
                const prevPlayer = prevPlayers.find(p => p.id === id);
                if (prevPlayer) {
                    leavingPlayers[id] = prevPlayer;
                    changed = true;
                    setTimeout(() => {
                        this.setState(prev => {
                            const newSlotMap = { ...prev.slotMap };
                            const newLeaving = { ...prev.leavingPlayers };
                            delete newSlotMap[id];
                            delete newLeaving[id];
                            return { slotMap: newSlotMap, leavingPlayers: newLeaving };
                        });
                    }, 400);
                } else {
                    delete slotMap[id];
                    changed = true;
                }
            }
        }

        this.prevPlayers = players;
        if (changed) {
            this.setState({ slotMap, leavingPlayers });
        }
    }

    bindNotificationListeners() {
        if (this.unBindPlayerJoined) this.unBindPlayerJoined();
        if (this.unBindPlayerLeft) this.unBindPlayerLeft();
        if (this.unBindAnimatePotato) this.unBindAnimatePotato();

        this.unBindPlayerJoined = this.props.room.room.onMessage("player_joined", (message) => {
            this.doNotification(`${message.player.name} has joined!`);
        });

        this.unBindPlayerLeft = this.props.room.room.onMessage("player_leave", (message) => {
            this.doNotification(`${message.player.name} has left`);
        });

        this.unBindAnimatePotato = this.props.room.room.onMessage("animate_potato", (message) => {
            this.animatePotato(message.id, message.animation);
        });
    }

    doNotification(text) {
        const id = ++this.notificationId;
        this.setState((prevState) => ({
            notifications: [...prevState.notifications, { id, text, exiting: false }]
        }));
        setTimeout(() => {
            this.setState((prevState) => ({
                notifications: prevState.notifications.map(n =>
                    n.id === id ? { ...n, exiting: true } : n
                )
            }));
            setTimeout(() => {
                this.setState((prevState) => ({
                    notifications: prevState.notifications.filter(n => n.id !== id)
                }));
            }, 300);
        }, 4000);
    }

    animateCSS = (element, animation, prefix = 'animate__') =>
        new Promise((resolve) => {
            const animationName = `${prefix}${animation}`;
            const node = typeof element === 'string' ? document.querySelector(element) : element;
            if (!node) return resolve();
            node.classList.add(`${prefix}animated`, animationName);
            function handleAnimationEnd(event) {
                event.stopPropagation();
                node.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }
            node.addEventListener('animationend', handleAnimationEnd, { once: true });
        });

    animatePotato(id, animation) {
        if (document.getElementById(`potato-${id}`)) {
            this.animateCSS(`#potato-${id}`, animation);
        }
    }

    toggleCollapse = () => {
        this.setState({ collapse: !this.state.collapse });
    }

    copyTextToClipboard = () => {
        const baseUrl = getBaseUrl();
        const text = `${baseUrl}/join?qrCode=${this.props.room.roomId}`;

        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(text);
        } else {
            document.execCommand('copy', true, text);
        }

        this.setState({ copiedLink: true });
        setTimeout(() => this.setState({ copiedLink: false }), 2000);
    }

    copyMirrorLink = () => {
        const baseUrl = getBaseUrl();
        const text = `${baseUrl}/connect?code=${this.props.room.roomId}`;
        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(text);
        } else {
            document.execCommand('copy', true, text);
        }

        this.setState({ copiedMirror: true });
        setTimeout(() => this.setState({ copiedMirror: false }), 2000);
    }


    closeRoom = () => {
        if (!this.state.confirmingClose) {
            this.setState({ confirmingClose: true });
            this.closeRoomTimeout = setTimeout(() => this.setState({ confirmingClose: false }), 3000);
            return;
        }
        clearTimeout(this.closeRoomTimeout);
        this.props.room.room.send("close_room");
        // Dispatch ROOM_LEAVE so Redux clears state.players / state.avatarList
        // before the next ROOM_JOIN. Without this, the host's previous players
        // array survives into the new room and onAdd appends new players on top
        // (causing duplicate rows in the lobby PlayerList — different sessionIds
        // visually look identical because name + avatar are the same).
        this.props.leaveRoom();
        this.props.navigate("/");
    }

    startLocationChecks() {
        if (this.props.room.roomOpen) {
            this.props.room.room.send("location_check", { gameId: "lobby", });

        }
        this.locationCheckInterval = setInterval(() => {
            if (this.props.room.roomOpen) {
                this.props.room.room.send("location_check", { gameId: "lobby", });
            }
        }, 10000);
    }

    renderPlayerSlots() {
        const maxPlayers = 8;
        const players = this.props.room.players || [];
        const slotMap = this.state.slotMap;

        const slots = new Array(maxPlayers).fill(null);
        for (const player of players) {
            const idx = slotMap[player.id];
            if (idx !== undefined) {
                slots[idx] = <Player player={player} key={player.id} tvApp />;
            }
        }
        // Render leaving players with exit animation
        for (const [id, player] of Object.entries(this.state.leavingPlayers)) {
            const idx = slotMap[id];
            if (idx !== undefined) {
                slots[idx] = <Player player={player} key={id} tvApp leaving />;
            }
        }
        for (let i = 0; i < maxPlayers; i++) {
            if (!slots[i]) {
                slots[i] = (
                    <div className={styles.emptySlot} key={`empty-${i}`}>
                        <div className={styles.emptyAvatar} />
                    </div>
                );
            }
        }

        // First row of 3, second row of 3, third row of 2 centered
        return (
            <div className={styles.playerSlots}>
                <div className={styles.playerRow}>{slots.slice(0, 3)}</div>
                <div className={styles.playerRow}>{slots.slice(3, 6)}</div>
                <div className={styles.playerRow}>{slots.slice(6, 8)}</div>
            </div>
        );
    }

    getQrUrl() {
        const baseUrl = getBaseUrl();
        if (this.props.isTvApp) {
            return `${baseUrl}/join?roku=true&loginAppType=${this.props.devices.appType}&qrCode=${this.props.room.roomId}`;
        }
        return `${baseUrl}/join?qrCode=${this.props.room.roomId}`;
    }

    render() {
        const isVisible = this.props.room.roomOpen && this.props.room.isHost;
        const shouldCollapse = !isVisible || (this.state.collapse && !window.location.href.includes("/lobby") && !this.props.isTvApp);

        return (
            <div key="side-bar" className={`${styles.sideBar} ${shouldCollapse ? styles.collapse : ''} ${isVisible ? styles.visible : ''} ${this.state.animateIn ? styles.animateIn : ''}`}>
                <div className={styles.card}>
                    <img className={styles.cloudLeft} src={cloudLeft} alt="" />
                    <img className={styles.cloudRight} src={cloudRight} alt="" />
                    <img className={styles.logo} src={Logo} alt="Game City" />
                    <p className={styles.subtitle}>
                        <strong>Scan the QR code</strong> to join the lobby!
                    </p>

                    <div className={styles.qrRow}>
                        <div className={styles.qrFrame}>
                            <QRCode
                                size={256}
                                style={{ width: "100%", height: "100%" }}
                                bgColor="transparent"
                                fgColor="#000000"
                                value={this.getQrUrl()}
                            />
                        </div>
                        <div className={styles.roomCodeArea}>
                            <div className={styles.roomCodePill}>
                                Room code: <strong>{this.props.room.roomId}</strong>
                            </div>
                            {!this.props.isTvApp &&
                                <div className={styles.copyButtons}>
                                    <button className={`${styles.copyBtn} ${this.state.copiedLink ? styles.copied : ''}`} onClick={this.copyTextToClipboard} title="Copy join link"><FaCopy /> {this.state.copiedLink ? 'Copied!' : 'Copy Link'}</button>
                                    {CONNECT_ENABLED && <button className={`${styles.copyBtn} ${this.state.copiedMirror ? styles.copied : ''}`} onClick={this.copyMirrorLink} title="Copy connect link"><FaTv /> {this.state.copiedMirror ? 'Copied!' : 'Connect'}</button>}
                                </div>
                            }
                        </div>
                    </div>

                    {CONNECT_ENABLED &&
                        <div className={styles.connectInvite}>
                            <p>
                                Got friends or family playing from another house? They can join via <strong>game.city/connect</strong> with this code.
                            </p>
                            {!this.props.isTvApp &&
                                <button
                                    type="button"
                                    className={styles.whatsConnectLink}
                                    onClick={() => this.setState({ showConnectInfo: true })}
                                >
                                    What's Connect?
                                </button>
                            }
                        </div>
                    }
                    {!this.props.isTvApp &&
                        <ConnectInfoModal
                            show={this.state.showConnectInfo}
                            onHide={() => this.setState({ showConnectInfo: false })}
                        />
                    }

                    <div className={styles.whosInHeader}>
                        <div className={styles.whosInRow}>
                            <span className={styles.whosInText}>WHO'S IN?</span>
                        </div>
                        <img className={styles.whosInUnderline} src={whosInUnderline} alt="" />
                    </div>
                    {this.renderPlayerSlots()}

                    {!this.props.isTvApp && !this.props.room.isMirror &&
                    <div className={styles.buttonGroup}>
                        <button className={`${styles.copyBtn} ${this.state.confirmingClose ? styles.confirmClose : ''}`} onClick={this.closeRoom}>
                            {this.state.confirmingClose ? 'Are you sure?' : 'Close Room'}
                        </button>
                    </div>
                    }
                </div>
                {this.state.notifications.length > 0 &&
                    <div className={styles.notifications}>
                        {this.state.notifications.map((n) => (
                            <div className={`${styles.notification} ${n.exiting ? styles.exiting : ''}`} key={n.id}>{n.text}</div>
                        ))}
                    </div>
                }
                {
                    isVisible && !window.location.pathname.includes("lobby") && !this.props.isTvApp &&
                    <div className={`${styles.collapseTab} ${shouldCollapse ? styles.collapsed : ''}`} onClick={this.toggleCollapse}>
                        <IoIosArrowDown className={styles.tabArrow} />
                        <span className={styles.tabLabel}>Lobby</span>
                    </div>
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        devices: state.devices
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        leaveRoom: () => dispatch(leaveRoom()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PlayerList));
